import * as React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";

import { EmailComponent } from "../components/templates/EmailComponent";
import { InitialPage } from "../components/organisms/InitialPage";
import { Dialog } from "../components/organisms/Dialog";
import { useZohoAuth } from "../hook/useZohoAuth";
import { zohoApi } from "../zohoApi";
import { editor, moduleNameMap, specialModules } from "../config/config";
import { EmailComponentPreview } from "../components/templates/EmailComponentPreview";
import { ZOHO_CONN_NAME } from "../config/serviceConstant";
// import { enqueueSnackbar } from "notistack";

const { useState, useEffect } = React;
const customActionPage = true;

export const CustomActionRoute = () => {
  const {
    module,
    accessToken,
    orgId,
    apiKey,
    zapiKey,
    configdata,
    dataCenterUrl,
    adminEmail,
  } = useZohoAuth();
  const [relatedListModule, setRelatedListModule] = useState();
  const [relationshipName, setRelationshipName] = useState();
  const [openEmail, setOpenEmail] = useState(false);
  const [openPreview, setOpenPreview] = useState(false);
  const [firstPage, setFirstPage] = useState();
  const [relatedListApis, setRelatedListApis] = useState([]);
  const [relatedListLoading, setRelatedListLoading] = useState();
  const [singleRecordDataLoading, setSingleRecordDataLoading] = useState();
  const [crmUsersEmail, setUsersCrmEmails] = useState([]);
  const [crmUsersEmailLoading, setCrmUsersEmailLoading] = useState(false);
  const [fromEmail, setFromEmail] = useState("");
  //-------------------
  const [subject, setSubject] = useState("");
  const [emailContent, setEmailContent] = React.useState("");
  const [editorType, setEditorType] = useState(editor.rich_text);
  const [finalRecords, setFinalRecords] = useState([]);
  //-------------------
  const [toArray, setToArray] = useState([]);
  const [ccArray, setCcArray] = useState([]);
  const [bccArray, setBccArray] = useState([]);
  //-------------------
  const [emailTemplates, setEmailTemplates] = useState([]);
  const [emailTemplatesLoading, setEmailTemplatesLoading] = useState(false);
  //-------------------
  const [selectedEmailTemplateId, setSelectedEmailTemplateId] = useState();
  //-------------------
  const [inventoryTemplates, setInventoryTemplates] = useState([]);
  const [inventoryTemplatesLoading, setInventoryTemplatesLoading] =
    useState(false);
  //-------------------
  const [selectedInventoryTemplate, setSelectedInventoryTemplate] = useState(
    []
  );
  //-------------------
  const [selectedFallbackEmail, setSelectedFallbackEmail] = React.useState("");
  const [isOwnerEmailSelected, setIsOwnerEmailSelected] = React.useState(false);
  //-------------------
  const [savedModule, setSavedModule] = useState();
  //-------------------
  const [emailFields, setEmailFields] = useState([]);
  const [fileFields, setFileFields] = useState([]);
  const [initPageContent, setInitPageContent] = React.useState(
    <CircularProgress />
  );
  //-------------------
  const [emailType, setEmailType] = useState();
  const [recordDataKeys, setRecordDataKeys] = useState([]);
  //-------------------
  const [configdataLoading, setConfigdataLoading] = useState(false);
  const settingSchema = React.useRef();

  const handlePreviewClose = () => {
    setOpenPreview(false);
    // zohoApi.auth.resizeWindow(blueprintPage ? minWindowBlueprint : minWindow);
  };

  // Check if there is accessToken or not.
  useEffect(() => {
    if (accessToken === null) {
      setInitPageContent(<h1>Not authenticated.</h1>);
    }
  }, [accessToken]);

  // Fetch org emails.
  useEffect(() => {
    async function getCrmEmails({ accessToken, dataCenterUrl }) {
      setCrmUsersEmailLoading(true);
      const { data: resp, error } = await zohoApi.user.getCrmUsersEmail({
        accessToken,
        dataCenterUrl,
      });

      // if (error || !resp || resp?.length == 0) {
      //   setFirstPage((prev) => false);
      //   setInitPageContent(<h1>{error}</h1>);
      //   enqueueSnackbar(error || `Something went wrong`, {
      //     variant: "error",
      //     autoHideDuration: 3000,
      //   });
      // }

      setUsersCrmEmails(resp);
      setFromEmail(resp?.[0]);
      if (resp?.[0]) {
        setEmailType({ type: "Org email", orgEmail: true });
      } else {
        setEmailType({ type: null, orgEmail: false });
      }
      setCrmUsersEmailLoading(false);
    }
    if (accessToken && dataCenterUrl) {
      getCrmEmails({ accessToken, dataCenterUrl });
    }
  }, [accessToken, dataCenterUrl]);

  // Fetch existing setting data.
  useEffect(() => {
    const loadDbConfig =
      orgId &&
      apiKey &&
      dataCenterUrl &&
      module &&
      accessToken &&
      configdata?.settingId;

    const fetchConfig = async () => {
      const dbResp = await zohoApi.config.getConfigFromDB({
        orgId,
        apiKey,
        dataCenterUrl,
        settingId: configdata?.settingId,
      });
      const parsedDbResp = await JSON.parse(
        dbResp?.data?.data?.setting_schema || {}
      );

      settingSchema.current = parsedDbResp;

      const activeModule =
        parsedDbResp?.relatedListModule || parsedDbResp?.module;

      const { data: allEmailFieldsData } =
        await zohoApi.record.getRecordsEmailAndLookupEmail({
          module: activeModule,
          dataCenterUrl,
          orgId,
          apiKey,
          connName: ZOHO_CONN_NAME,
        });
      setEmailFields(allEmailFieldsData);

      const { data: fileFieldsData } =
        await zohoApi.record.getEmailAndFileFields({
          module: activeModule,
          accessToken,
          dataCenterUrl,
        });
      const fileFields = await fileFieldsData?.fileFields;
      setFileFields(fileFields);
      //------------

      await fetchEmailTemplates({
        module: activeModule,
        accessToken,
        dataCenterUrl,
      });

      if (specialModules.includes(activeModule)) {
        await fetchInventoryTemplates({
          module: activeModule,
          accessToken,
          dataCenterUrl,
        });
      }
      //---------
      setFromEmail(parsedDbResp?.fromEmail);
      setSubject(parsedDbResp?.subject);
      setEmailContent(parsedDbResp?.emailContent);
      setEditorType(editor.template);
      setSavedModule(parsedDbResp?.module);
      setRelatedListModule(parsedDbResp?.relatedListModule);
      setRelationshipName(parsedDbResp?.relationshipName);
      setIsOwnerEmailSelected(parsedDbResp?.ownerEmailSelected);
      setSelectedFallbackEmail(parsedDbResp?.fallbackEmail);
      setSelectedEmailTemplateId(parsedDbResp?.selectedEmailTemplateId);
      setSelectedInventoryTemplate(parsedDbResp?.selectedInventoryTemplate);
      //---------
      setOpenEmail(true);
      setConfigdataLoading(false);
    };
    if (loadDbConfig) {
      setConfigdataLoading(true);
      fetchConfig();
    }
  }, [
    orgId,
    apiKey,
    dataCenterUrl,
    module,
    accessToken,
    configdata?.settingId,
  ]);

  // TipTap popover option keys.
  useEffect(() => {
    const getRecordDataKeys = async ({ entity }) => {
      const resp = await zohoApi.record.getFieldsAndData({
        entity,
        flatten: [],
        returnValues: ["fields"],
      });
      let moduleKeys = [];

      Object.keys(resp?.fieldNames).forEach((moduleName) => {
        resp?.fieldNames?.[moduleName]?.forEach((indvField) => {
          if (moduleName !== entity) {
            moduleKeys.push(`${entity}.${moduleName}.${indvField.api_name}`);
          } else {
            moduleKeys.push(`${entity}.${indvField.api_name}`);
          }
        });
      });

      setRecordDataKeys([...moduleKeys], "userSignature");
    };
    if (module) {
      getRecordDataKeys({
        entity: module,
      });
    }
  }, [module]);

  const fetchRelatedListApis = async ({
    module,
    accessToken,
    dataCenterUrl,
  }) => {
    const { data: resp } = await zohoApi.record.getRelatedListApis({
      module,
      accessToken,
      dataCenterUrl,
    });
    setRelatedListApis(resp);
    setFirstPage(true);
  };

  useEffect(() => {
    if (dataCenterUrl && module && accessToken && !configdata?.settingId) {
      // setFirstPage(true);
      fetchRelatedListApis({ module, accessToken, dataCenterUrl });
    }
  }, [dataCenterUrl, module, accessToken, configdata?.settingId]);

  const fetchEmailTemplates = async ({
    module,
    accessToken,
    dataCenterUrl,
  }) => {
    setEmailTemplatesLoading(true);
    const { data: templates } = await zohoApi.email.getEmailTemplateList({
      module,
      accessToken,
      dataCenterUrl,
    });
    setEmailTemplates(templates);
    setEmailTemplatesLoading(false);
  };

  const fetchInventoryTemplates = async ({
    module,
    accessToken,
    dataCenterUrl,
  }) => {
    setInventoryTemplatesLoading(true);

    const { data: inventoryTemplates } =
      await zohoApi.inventory.getInventoryTemplateList({
        module,
        accessToken,
        dataCenterUrl,
      });

    if (inventoryTemplates?.length < 1) {
      setInitPageContent(<h1>No inventory template.</h1>);
      return;
    }

    setInventoryTemplates(inventoryTemplates);
    setInventoryTemplatesLoading(false);
  };

  const onClickSingleRecord = async () => {
    if (module && accessToken && dataCenterUrl) {
      setSavedModule(module);
      setSingleRecordDataLoading(true);
      setRelatedListModule(undefined);
      setRelationshipName(undefined);

      const { data: allEmailFieldsData } =
        await zohoApi.record.getRecordsEmailAndLookupEmail({
          module,
          dataCenterUrl,
          orgId,
          apiKey,
          connName: ZOHO_CONN_NAME,
        });
      setEmailFields(allEmailFieldsData);

      const { data: fileFieldsData } =
        await zohoApi.record.getEmailAndFileFields({
          module,
          accessToken,
          dataCenterUrl,
        });
      const fileFields = await fileFieldsData?.fileFields;
      setFileFields(fileFields);
      //------------

      await fetchEmailTemplates({ module, accessToken, dataCenterUrl });
      if (specialModules.includes(module)) {
        await fetchInventoryTemplates({ module, accessToken, dataCenterUrl });
      }

      setOpenEmail(true);
      setSingleRecordDataLoading(false);
    }
  };

  const onSelectAutocomplete = async (e, value) => {
    if (value && accessToken && dataCenterUrl) {
      const newModule = value?.module?.api_name;
      const relationshipName = value?.api_name;
      setRelatedListModule(newModule);
      setRelationshipName(relationshipName);
      setRelatedListLoading(true);
      setSavedModule(newModule);
      setFinalRecords([]);

      const { data: allEmailFieldsData } =
        await zohoApi.record.getRecordsEmailAndLookupEmail({
          module: newModule,
          dataCenterUrl,
          orgId,
          apiKey,
          connName: ZOHO_CONN_NAME,
        });
      setEmailFields(allEmailFieldsData);

      const { data: fileFieldsData } =
        await zohoApi.record.getEmailAndFileFields({
          module: newModule,
          accessToken,
          dataCenterUrl,
        });
      //------------
      const fileFields = await fileFieldsData?.fileFields;
      setFileFields(fileFields);
      //------------
      const dynamic = `${newModule}?fields=Owner,${moduleNameMap(newModule)},`;
      const url = `${dataCenterUrl}/crm/v6/${dynamic}`;
      const { data } = await zohoApi.record.getBulkRecordDetailsRestAPI({
        accessToken,
        url,
      });
      setFinalRecords(data);

      await fetchEmailTemplates({
        module: newModule,
        accessToken,
        dataCenterUrl,
      });
      if (specialModules.includes(module)) {
        await fetchInventoryTemplates({ module, accessToken, dataCenterUrl });
      }
      setOpenEmail(true);

      setRelatedListLoading(false);
    }
  };

  useEffect(() => {
    const getFinalRecords = async () => {
      let fields = `?fields=Owner,${moduleNameMap(module)},`;
      const dynamic = module + fields;
      const url = `${dataCenterUrl}/crm/v6/${dynamic}`;
      const { data } = await zohoApi.record.getBulkRecordDetailsRestAPI({
        accessToken,
        url,
      });
      setFinalRecords(data);
    };
    if (module && accessToken) {
      getFinalRecords();
    }
  }, [module, accessToken, dataCenterUrl]);

  const handleEmailBack = () => {
    setOpenEmail(false);
    // setFirstPage(true);
    setSavedModule(undefined);
    settingSchema.current = null;
    if (relatedListApis?.length === 0) {
      fetchRelatedListApis({ module, accessToken, dataCenterUrl });
    }
  };

  return (
    <>
      <Box
        sx={{
          height: "100vh",
          pt: "30px",
          pl: "30px",
          pr: "30px",
          bgcolor: "rgba(245, 245, 245, 1)",
          display: "grid",
          placeItems: "center",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          {initPageContent}
          {configdataLoading ? "Fetching Data, please wait..." : null}
        </Box>
      </Box>

      <Dialog dialogOpen={firstPage} handleDialogClose={() => {}}>
        <Box
          sx={{
            bgcolor: "rgba(245, 245, 245, 1)",
            height: "100vh",
            width: "93%",
            m: "0 auto",
            mb: "40px",
            display: "flex",
            alignItems: "center",
            borderRadius: "1em",
          }}
        >
          <InitialPage
            relatedListApis={relatedListApis}
            onClickSingleRecord={onClickSingleRecord}
            singleRecordDataLoading={singleRecordDataLoading}
            onSelectAutocomplete={onSelectAutocomplete}
            relatedListLoading={relatedListLoading}
            customActionPage={customActionPage}
          />
        </Box>
      </Dialog>

      <Dialog dialogOpen={openEmail} handleDialogClose={handleEmailBack}>
        <EmailComponent
          module={module}
          recordId={""}
          zapiKey={zapiKey}
          accessToken={accessToken}
          relatedListModule={relatedListModule}
          setRelatedListModule={setRelatedListModule}
          relationshipName={relationshipName}
          setRelationshipName={setRelationshipName}
          freeSolo={false}
          noParentRecord={true}
          handleEmailBack={handleEmailBack}
          //------
          crmUsersEmail={crmUsersEmail}
          crmUsersEmailLoading={crmUsersEmailLoading}
          //------
          selectedEmailTemplateId={selectedEmailTemplateId}
          setSelectedEmailTemplateId={setSelectedEmailTemplateId}
          //------
          emailType={emailType}
          setEmailType={setEmailType}
          //------
          fromEmail={fromEmail}
          setFromEmail={setFromEmail}
          //------
          emailTemplates={emailTemplates}
          emailTemplatesLoading={emailTemplatesLoading}
          //------
          inventoryTemplates={inventoryTemplates}
          inventoryTemplatesLoading={inventoryTemplatesLoading}
          selectedInventoryTemplate={selectedInventoryTemplate}
          setSelectedInventoryTemplate={setSelectedInventoryTemplate}
          //------
          selectedFallbackEmail={selectedFallbackEmail}
          setSelectedFallbackEmail={setSelectedFallbackEmail}
          isOwnerEmailSelected={isOwnerEmailSelected}
          setIsOwnerEmailSelected={setIsOwnerEmailSelected}
          //------
          storage={{}}
          emailOptions={emailFields}
          finalRecords={[]}
          inventoryModule={
            relatedListModule
              ? specialModules.includes(relatedListModule)
              : specialModules.includes(module)
          }
          dataCenterUrl={dataCenterUrl}
          //------
          subject={subject}
          setSubject={setSubject}
          emailContent={emailContent}
          setEmailContent={setEmailContent}
          editorType={editorType}
          setEditorType={setEditorType}
          //------
          adminEmail={adminEmail}
          handlePreviewOpen={() => {
            setOpenPreview(true);
          }}
          //-----------
          toArray={toArray}
          setToArray={setToArray}
          ccArray={ccArray}
          setCcArray={setCcArray}
          bccArray={bccArray}
          setBccArray={setBccArray}
          //------
          recordDataKeys={recordDataKeys}
          //------
          savedModule={savedModule}
          customActionPage={customActionPage}
          orgId={orgId}
          apiKey={apiKey}
          configdata={configdata}
          settingSchema={settingSchema.current}
          setConfigdataLoading={setConfigdataLoading}
          hideCloseButton={true}
        />
      </Dialog>

      <Dialog dialogOpen={openPreview} handleDialogClose={handlePreviewClose}>
        <EmailComponentPreview
          module={module}
          relatedListModule={relatedListModule}
          finalRecords={finalRecords}
          subject={subject}
          emailContent={emailContent}
          handlePreviewClose={handlePreviewClose}
          orgId={orgId}
          apiKey={apiKey}
          dataCenterUrl={dataCenterUrl}
          fromEmail={fromEmail}
        />
      </Dialog>
    </>
  );
};
